import _merge from 'lodash/merge';
import { RENDERING_CONTEXT, safetyMargins } from '@bedrock-rdk/constants';
import { Lightning } from '@lightningjs/sdk';
import { imageOptions, sizes, templates } from './AlertView.constants';
import { BrandIcon } from '../brand-icon/brandIcon.component';
import { colors, defaultContext, getInitialStyle, getWordWrapWidth } from './AlertView.style';
import { Button } from '../button/button.component';
import { SELECTED_SIGNAL } from '../signals';
import { makeTextPatch } from '../utils/templates';

/**
 * This Organism displays event, alert, or error messages.
 *
 * @version 1.7.1
 * @see https://zeroheight.com/726d5c282/v/latest/p/26a7c3-alertview--v171
 */
class AlertView extends Lightning.Component {
  static _template() {
    return _merge(
      {
        rect: true,
        Background: {},
        Logo: {
          type: BrandIcon,
        },
        Container: {
          Title: {},
          Description: {},
          Button: {
            type: Button,
          },
          ExtraDetails: {},
        },
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
    this._contentPadding = 0;
    this._config = { ...sizes[templates.AlertView][RENDERING_CONTEXT.GENERAL][this._style.screenSize] };
  }

  _detach() {
    this.tag('Background').removeAllListeners('txLoaded');
    this._item = undefined;
  }

  set item({ content, config, renderingContext = RENDERING_CONTEXT.GENERAL }) {
    this.tag('Background').once('txLoaded', () => {
      this.tag('Background').setSmooth('alpha', 1);
    });

    const { screenSize, colorMode } = this._style;

    this._config = config || this._config;
    this._item = content;

    const wordWrapWidth = getWordWrapWidth(screenSize, this._config.w);
    const textColor = colors.text[colorMode];

    this.patch({
      w: this._config.w,
      h: this._config.h,
      Background: {
        w: this._config.w,
        h: this._config.h,
        alpha: 0.0001,
        src: content.image ? content.image.src : '',
      },
      Logo: {
        y: renderingContext === RENDERING_CONTEXT.SEARCH ? 0 : safetyMargins.vertical[screenSize],
      },
      Container: {
        w: this._config.w,
        h: this._config.h,
        Title: makeTextPatch(content.title || '', wordWrapWidth, textColor),
        Description: makeTextPatch(content.description || '', wordWrapWidth, textColor),
        Button: {
          label: (content.action && content.action.label) || '',
        },
        ExtraDetails: makeTextPatch(content.extraDetails || '', wordWrapWidth, textColor),
      },
    });
    this.contentPadding = this._contentPadding;
  }

  set contentPadding(value) {
    const offset = Number.isFinite(value) ? value : 0;

    this.patch({
      Container: {
        x: offset,
        w: this._config.w - offset,
      },
    });

    this._contentPadding = value;
  }

  _handleEnter() {
    this.signal(SELECTED_SIGNAL, this._item);

    return true;
  }

  _getFocused() {
    return this.tag('Button');
  }
}

AlertView.Templates = templates;
AlertView.Sizes = sizes;
AlertView.ImageOptions = imageOptions;

export default AlertView;
